import { render, staticRenderFns } from "./DeliveryViewer.vue?vue&type=template&id=38642500&scoped=true"
import script from "./DeliveryViewer.vue?vue&type=script&lang=js"
export * from "./DeliveryViewer.vue?vue&type=script&lang=js"
import style0 from "./DeliveryViewer.vue?vue&type=style&index=0&id=38642500&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38642500",
  null
  
)

export default component.exports